export enum Currency {
  NotDefined = 'NotDefined',
  ALL = 'All',

  TJISEK = 'TJISEK',
  SEK = 'SEK',

  TJIEUR = 'TJIEUR',
  EUR = 'EUR'
}

export interface CurrencyInfo {
  currency: string
  symbol: string
}

const currencyInfo: CurrencyInfo[] = [
  { currency: Currency.NotDefined, symbol: '' },
  { currency: Currency.ALL, symbol: '' },

  { currency: Currency.TJISEK, symbol: 'kr' },
  { currency: Currency.SEK, symbol: 'kr' },

  { currency: Currency.TJIEUR, symbol: '€' },
  { currency: Currency.EUR, symbol: '€' }
]

export function getCurrencyInfo(currency: string): CurrencyInfo {
  return currencyInfo.find(x => x.currency === currency)!
}

export default Currency
